import React from 'react';
import './AdminHeader.css';

const AdminHeader = ({ onToggleSidebar }) => {
  return (
    <header className="admin-header">
      <div className="admin-header-content">
        <h1 className="admin-header-title">Admin Dashboard</h1>
        <button
          className="admin-header-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <span className="admin-toggle-icon">☰</span>
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;

